import { utc } from '@date-fns/utc'
import { Dialog } from '@mui/material'
import {
    createFileRoute,
    Outlet,
    stripSearchParams,
} from '@tanstack/react-router'
import { startOfDay } from 'date-fns'
import * as React from 'react'
import { z } from 'zod/v4-mini'
import { EditTrackingsPendingComponent } from '@/features/edit-trackings/components/EditTrackingsPendingComponent'
import { lazyLoad } from '@/helper/lazyLoad'

const LazyEditTrackings = lazyLoad(
    () => import('@/features/edit-trackings/components/EditTrackings'),
    'EditTrackings'
)

/**
 * Renders the content directly and only adds the `EditTrackings` dialog.
 */
const RouteComponent = () => {
    const { day, showEditTrackings, trackingId } = Route.useSearch()
    const parsedDay = React.useMemo(
        () => startOfDay(day ? new Date(day) : new Date(), { in: utc }),
        [day]
    )

    return (
        <>
            <Outlet />

            <Dialog
                open={showEditTrackings}
                fullWidth={true}
                maxWidth={'md'}
                slotProps={{
                    paper: {
                        style: { height: '100%', containerType: 'inline-size' },
                    },
                }}
            >
                <React.Suspense
                    fallback={
                        <EditTrackingsPendingComponent
                            day={parsedDay}
                            trackingId={trackingId}
                        />
                    }
                >
                    <LazyEditTrackings
                        key={day}
                        day={parsedDay}
                        trackingId={trackingId}
                    />
                </React.Suspense>
            </Dialog>
        </>
    )
}

export const Route = createFileRoute('/__base-layout/__edit-trackings')({
    component: RouteComponent,

    validateSearch: z.object({
        showEditTrackings: z._default(z.boolean(), false),
        day: z.optional(z.iso.date()),
        trackingId: z.optional(z.string()),
    }),

    search: { middlewares: [stripSearchParams({ showEditTrackings: false })] },
})
